import { customerLocation, regions, cities, countries} from "constants/customer";


const initialState = {
  customerLocation: {},
  regions: {},
  cities: {},
  countries: {}
};

const customerLocationList = (state = initialState, action) => {
  switch (action.type) {
    case customerLocation:
      return { ...state, customerLocation: action.payload };

    case regions:
      return { ...state, regions: action.payload };

    case cities:
      return { ...state, cities: action.payload };

    case countries:
      return { ...state, countries: action.payload };

    default:
      return state;
  }
};

export default customerLocationList;
